export const card = {
  background: "#1a1d27",
  borderRadius: 16,
  border: "1px solid rgba(255,255,255,0.07)",
  padding: "16px",
  marginBottom: 12,
};

export const btn = {
  background: "#3b82f6", color: "white", border: "none",
  borderRadius: 14, padding: "15px 20px", fontSize: 15, fontWeight: 700,
  cursor: "pointer", width: "100%", display: "flex",
  alignItems: "center", justifyContent: "center", gap: 8,
  boxShadow: "0 4px 20px rgba(59,130,246,0.35)",
};

export const inputStyle = {
  width: "100%", background: "#22263a",
  border: "1px solid rgba(255,255,255,0.07)",
  borderRadius: 10, padding: "0 14px", height: 44,
  color: "#f1f5f9", fontSize: 14, boxSizing: "border-box",
  outline: "none", colorScheme: "dark", marginBottom: 10,
};

export const fieldLabel = {
  fontSize: 11, color: "#64748b", marginBottom: 5, fontWeight: 700, letterSpacing: 0.5,
};

export const savedRow = {
  display: "flex", alignItems: "center", justifyContent: "space-between",
  padding: "10px 14px", background: "#22263a", borderRadius: 10, marginBottom: 8,
  border: "1px solid rgba(255,255,255,0.07)",
};